var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ib-link-wrapper font-outfit-light"},[_c('router-link',{staticClass:"d-flex align-items-center",style:({'font-size': _vm.fontSize}),attrs:{"to":_vm.to}},[_vm._v(" "+_vm._s(_vm.text)+" "),_c('div',{staticClass:"icon-wrapper"},[_c('i',{staticClass:"icon ib-icon ib-icon-arrow-right-2"})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }